// extracted by mini-css-extract-plugin
export var centerText = "_5i-8";
export var container = "_5i-0";
export var doughnutContainer = "_5i-7";
export var legend = "_5i-a";
export var legendItemColorDisplay = "_5i-b";
export var legendItemLabel = "_5i-d";
export var legendItemValue = "_5i-c";
export var lg = "_5i-5";
export var maxWidth = "_5i-9";
export var md = "_5i-4";
export var responsive = "_5i-6";
export var sm = "_5i-3";
export var xs = "_5i-2";
export var xxs = "_5i-1";